import { GridColumnVisibilityModel } from '@mui/x-data-grid';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching');

export const ACTIONS_COLUMN_FIELD = t('table.columns.actions');

export const DEFAULT_COLUMN_VISIBILITY_MODEL: GridColumnVisibilityModel = {
  draggableHandle: false,
  resumeDetails: true,
  match: true,
  location: false,
  currentFeedback: false,
  schools: false,
  degree: false,
  discipline: false,
  tags: false,
  jobPost: false,
  // Always-visible columns
  fullName: true,
  [ACTIONS_COLUMN_FIELD]: true,
};
